import { useGlobal } from '@/utils/useGlobal';
import { TweenMax } from 'gsap';
import lottie from 'lottie-web';
import css from './index.module.scss';

export default function MhB({}: any) {
    const { useEffect, useState, useLang, useRouter, isMobile } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('waveportableairconditioner');

    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    const startH = layoutH / 3;
    const endH = layoutH / 4;
    const durationH1 = '30%';

    const [isEnterA, setIsEnterA] = useState(false);
    const [isEnterB, setIsEnterB] = useState(false);
    const [isEnterC, setIsEnterC] = useState(false);
    let controller;
    let lottieHeaderA;
    let lottieHeaderB;
    let lottieHeaderC;
    let lottieHeaderD;

    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        if (!lottieHeaderA) {
            lottieHeaderA = lottie.loadAnimation({
                container: document.querySelector('.airPro-lottie-a'),
                renderer: 'svg',
                loop: false,
                autoplay: false,
                path: 'https://websiteoss.ecoflow.com/media/mh200/lottlejson/5924fd430a4d177e4a2c0b7fe77e4d0f.json',
            });
        }
        if (!lottieHeaderB) {
            lottieHeaderB = lottie.loadAnimation({
                container: document.querySelector('.airPro-lottie-b'),
                renderer: 'svg',
                loop: false,
                autoplay: false,
                path: 'https://websiteoss.ecoflow.com/media/mh200/lottlejson/fca56a8c477ac6631601dc212b71dede.json',
            });
        }
        if (!lottieHeaderC) {
            lottieHeaderC = lottie.loadAnimation({
                container: document.querySelector('.airPro-lottie-c'),
                renderer: 'svg',
                loop: false,
                autoplay: false,
                path: 'https://websiteoss.ecoflow.com/media/mh200/lottlejson/587559113e1cb03a99ea47a8264c30bd.json',
            });
        }
        if (!lottieHeaderD) {
            lottieHeaderD = lottie.loadAnimation({
                container: document.querySelector('.airPro-lottie-d'),
                renderer: 'svg',
                loop: false,
                autoplay: false,
                path: 'https://websiteoss.ecoflow.com/media/mh200/lottlejson/581babac7cdaf1bd5db5e96cd976824c.json',
            });
        }
    }, []);

    useEffect(() => {
        const triggerElementA1 = '.mhb .prob-section-1';
        // 场景A--进入
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: triggerElementA1, //触发元素
            offset: startH, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: durationH1, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA1 = TweenMax.to(triggerElementA1, 0.5, {
            opacity: 1,
            ease: 'none',
        });
        sceneA1.setTween(tweenA1);
        sceneA1.on('progress', (self: any) => {
            lottieHeaderA?.goToAndStop(self.progress * 100, true);
        });
        // 场景A--离开
        const sceneA2 = new ScrollMagic.Scene({
            triggerElement: triggerElementA1, //触发元素
            offset: -endH, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: durationH1, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA2 = TweenMax.to(triggerElementA1, 0.5, {
            opacity: 0,
            ease: 'none',
        });
        sceneA2.setTween(tweenA2);
        controller.addScene(sceneA1).addScene(sceneA2);
    }, []);

    useEffect(() => {
        const triggerElementA1 = '.mhb .prob-section-2';
        //const video = document.getElementById('airProBvideo1');
        // 场景A--进入
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: triggerElementA1, //触发元素
            offset: startH, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: durationH1, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA1 = TweenMax.to(triggerElementA1, 0.5, {
            opacity: 1,
            ease: 'none',
        });
        sceneA1.on('progress', (self: any) => {
            lottieHeaderB?.goToAndStop(self.progress * 100, true);
        });
        sceneA1.setTween(tweenA1);
        // 场景A--离开
        const sceneA2 = new ScrollMagic.Scene({
            triggerElement: triggerElementA1, //触发元素
            offset: -endH, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: durationH1, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA2 = TweenMax.to(triggerElementA1, 0.5, {
            opacity: 0,
            ease: 'none',
        });
        sceneA2.setTween(tweenA2);
        controller.addScene(sceneA1).addScene(sceneA2);
    }, []);

    useEffect(() => {
        const triggerElementA1 = '.mhb .prob-section-3';
        // 场景A--进入
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: triggerElementA1, //触发元素
            offset: startH, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: durationH1, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA1 = TweenMax.to(triggerElementA1, 0.5, {
            opacity: 1,
            ease: 'none',
        });
        sceneA1.on('progress', (self: any) => {
            lottieHeaderC?.goToAndStop(self.progress * 100, true);
        });
        sceneA1.setTween(tweenA1);
        // 场景A--离开
        const sceneA2 = new ScrollMagic.Scene({
            triggerElement: triggerElementA1, //触发元素
            offset: -endH, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: durationH1, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA2 = TweenMax.to(triggerElementA1, 0.5, {
            opacity: 0,
            ease: 'none',
        });
        sceneA2.setTween(tweenA2);
        controller.addScene(sceneA1).addScene(sceneA2);
    }, []);

    useEffect(() => {
        const triggerElementA1 = '.mhb .prob-section-4';
        // 场景A--进入
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: triggerElementA1, //触发元素
            offset: startH, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: durationH1, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA1 = TweenMax.to(triggerElementA1, 0.5, {
            opacity: 1,
            ease: 'none',
        });
        sceneA1.on('progress', (self: any) => {
            lottieHeaderD?.goToAndStop(self.progress * 100, true);
        });
        sceneA1.setTween(tweenA1);
        // 场景A--离开
        const sceneA2 = new ScrollMagic.Scene({
            triggerElement: triggerElementA1, //触发元素
            offset: -endH, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: durationH1, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA2 = TweenMax.to(triggerElementA1, 0.5, {
            opacity: 0,
            ease: 'none',
        });
        sceneA2.setTween(tweenA2);
        controller.addScene(sceneA1).addScene(sceneA2);
    }, []);

    return (
        <div className={`${css.mhB} mhb ${isMobile ? 'mhB-h5' : 'mhB-pc'}`}>
            <div className={`prob-section-box ${isEnterA ? 'isEnterA' : ''} ${isEnterB ? 'isEnterB' : ''} ${isEnterC ? 'isEnterC' : ''}`}>
                <div className="prob-section prob-section-1">
                    <div className="airPro-lottie airPro-lottie-a"></div>
                    <div className="prob-msg-out">
                        <div className="prob-msg">{t('mh200.mhB_ms1')}</div>
                    </div>
                </div>
                <div className="prob-section prob-section-2">
                    <div className="airPro-lottie airPro-lottie-b"></div>
                    <div className="prob-msg-out">
                        <div className="prob-msg">{t('mh200.mhB_ms2')}</div>
                    </div>
                </div>
                <div className="prob-section prob-section-3">
                    <div className="airPro-lottie airPro-lottie-c"></div>
                    <div className="prob-msg-out">
                        <div className="prob-msg">{t('mh200.mhB_ms3')}</div>
                    </div>
                </div>
                <div className="prob-section prob-section-4">
                    <div className="airPro-lottie airPro-lottie-d"></div>
                    <div className="prob-msg-out">
                        <div className="prob-msg">{t('mh200.mhB_ms4')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
